import { parseEnquiryMore, type EnquiryRow } from "./enquiry-helpers";

const MESSAGE_FORM_TYPE_PREFIXES: Record<string, string> = {
    "[Services]": "services",
    "[Careers]": "careers",
    "[Leads]": "leads",
};

const readTopLevelFormType = (row: EnquiryRow) => {
    const record = row as Record<string, unknown>;
    const value = record.formType ?? record.form_type ?? record.FormType;
    return typeof value === "string" ? value.trim() : "";
};

const inferFormTypeFromMessage = (message: string) => {
    for (const [prefix, formType] of Object.entries(MESSAGE_FORM_TYPE_PREFIXES)) {
        if (message.startsWith(prefix)) return formType;
    }

    if (/^\[[^\]]+\]/.test(message)) return "leads";

    return "";
};

export const resolveEnquiryFormType = (row: EnquiryRow): string => {
    const more = parseEnquiryMore(row);
    if (more.formType?.trim()) return more.formType.trim();

    const topLevel = readTopLevelFormType(row);
    if (topLevel) return topLevel;

    return inferFormTypeFromMessage((row.message ?? "").trim());
};
